import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Alert } from "react-bootstrap";

const CONTACT_SURFACE = "contact";
const PHONE_NUMBER_SETTINGS_PATH = "/users/phone_number/edit";
const GUIDANCE_COPY =
  "You can send texts to leads, but replies won't forward to your cell until you set up a forwarding number.";

const hasValue = (value) =>
  typeof value === "string" ? value.trim().length > 0 : Boolean(value);

const ForwardingNumberGuidance = ({ smsNumber = null, surface = null }) => {
  const isEligible =
    surface === CONTACT_SURFACE &&
    hasValue(smsNumber?.service_number) &&
    !hasValue(smsNumber?.forward_number);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (!isEligible) {
      setDismissed(false);
    }
  }, [isEligible]);

  if (!isEligible || dismissed) {
    return null;
  }

  return (
    <Alert
      variant="info"
      dismissible
      onClose={() => setDismissed(true)}
      className="py-2 px-3 mb-3"
    >
      <span>{GUIDANCE_COPY}</span>{" "}
      <a href={PHONE_NUMBER_SETTINGS_PATH}>Set up now</a>
    </Alert>
  );
};

ForwardingNumberGuidance.propTypes = {
  smsNumber: PropTypes.shape({
    service_number: PropTypes.string,
    forward_number: PropTypes.string,
  }),
  surface: PropTypes.string,
};

export default ForwardingNumberGuidance;
